import DroneViewer from "./Drone Viewer";
import { AdminRouter } from "./admin/routes/AdminRouter";
import { useBrowserPathname } from "./hooks/useBrowserPathname";
import StudioRedirectInterstitial from "./StudioRedirectInterstitial";
import ROICalculator from "./roi/ROICalculator";

function isAdminAppPath(pathname: string): boolean {
  return (
    pathname === "/admin" ||
    pathname.startsWith("/admin/") ||
    pathname === "/superadmin" ||
    pathname.startsWith("/superadmin/")
  );
}

function isViewerPath(pathname: string): boolean {
  return pathname.startsWith("/viewer/");
}

function isROIPath(pathname: string): boolean {
  return pathname === "/roi" || pathname === "/roi/";
}

export default function AppRoot() {
  const pathname = useBrowserPathname();

  const hostname = typeof window === 'undefined' ? '' : window.location.hostname;

  // ROI Calculator — public, no auth, available on any host at /roi
  if (isROIPath(pathname)) {
    return <ROICalculator />;
  }

  // On the studio host we only allow admin routes and viewer routes;
  // everything else shows an interstitial that redirects to the admin sign-in.
  if (hostname === 'studio.metaphysical-labs.com') {
    if (isAdminAppPath(pathname)) {
      return <AdminRouter data-oid="zbun-me" />;
    }

    // Viewer routes (e.g. /viewer/admin/weijia/pergola-pro) render the 3D viewer
    if (isViewerPath(pathname)) {
      return (
        <div data-testid="viewer-app" data-oid="i_lims:">
          <DroneViewer data-oid="-kyh5b4" />
        </div>
      );
    }

    return <StudioRedirectInterstitial />;
  }

  // The pergola viewer exception is only for the app host at /example.
  if (hostname === 'app.metaphysical-labs.com' && pathname === '/example') {
    return (
      <div data-testid="viewer-app" data-oid="i_lims:">
        <DroneViewer data-oid="-kyh5b4" />
      </div>
    );
  }

  if (isAdminAppPath(pathname)) {
    return <AdminRouter data-oid="zbun-me" />;
  }

  return (
    <div data-testid="viewer-app" data-oid="i_lims:">
      <DroneViewer data-oid="-kyh5b4" />
    </div>
  );
}
